import axios from "@/plugins/http.service.js";
export default {
    getNewsAndEvents() {
        return axios.post("api/web/new-event/get-news-and-events")
    },
}

